module.exports = __webpack_public_path__ + "img/personal-coaching.fd7457d6.png";